import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
// import { UtilityService } from 'src/app/services/utility.service';
import { Router } from '@angular/router';
import { UtilityService } from 'src/app/shared/utils/utility.service';

@Component({
  selector: 'app-like-dislike',
  templateUrl: './like-dislike.component.html',
  styleUrls: ['./like-dislike.component.css']
})
export class LikeDislikeComponent implements OnInit {
  showReportFeedback: boolean = false;
  assessmentResult: number = 0;
  @Input() userFeedback;
  @Input() _element;
  @Input() id;
  @Output() reportFeedback = new EventEmitter<any>();
  @Output() likeDislike = new EventEmitter<any>();

  constructor(private utilityService: UtilityService, private router: Router) { }

  ngOnInit() {
    this.showReportFeedback = !this.router.url.includes('assessments');
    this.utilityService.assessmentFeedbacks$.subscribe(res => {
      this.assessmentResult = res[this.id]
    })
  }

  _reportFeedback() {
    this.reportFeedback.emit(this._element);
    this.utilityService.updateEngagement('EntusiasticAdoption', 'ReportQuestionFeedback', 2).subscribe();
  }

  _likeDislike(like) {
    this.likeDislike.emit(like);
  }

}
